export enum NotificationDataType {
  Alertas = 'alertas',
  MensajesClientes = 'mensajes_clientes',
  PeticionesAirbnb = 'peticiones_airbnb',
  ReservasEnEspera = 'reservas_en_espera',
  ReservasSinAsignar = 'reservas_sin_asignar',
  ReservasNoLeidas = 'reservas_no_leidas'
}

export interface NotificationData {
  date: string
  id: string
  message?: string
  title: string
  type: NotificationDataType
  channelName?: string
  entityId?: string
  hotelName?: string
  identifier?: string
  roomTypeName?: string
}
